import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import Grid from "@/components/child/grid/grid";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import multiselectComponent from "@/components/child/multiSelect/multiSelect.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import searchComboMultiSelectComponent from "@/components/child/searchComboMultiSelect/searchComboMultiSelect.vue";
import ConfiguracoesImpresaoPDFComponent from "@/components/parent/relatorio/configuracoesImpresaoPDF";
import configuracoesImpresaoPDFComponent from "@/components/parent/relatorio/configuracoesImpresaoPDF.vue";
import ConfiguracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS";
import configuracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS.vue";
import CriteriosComponent from "@/components/parent/relatorio/criterios";
import criteriosComponent from "@/components/parent/relatorio/criterios.vue";
import { Component, Watch } from "@/decorators";
import ConfiguracaoImpressaoModel from "@/models/configuracaoImpressaoModel";
import ControleReclamacaoStatus from "@/models/enum/controleReclamacaoStatus";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import GatewayPagamentoProvider from "@/models/enum/financeiro/gatewayPagamentoProvider";
import MesesDoAno from "@/models/enum/mesesDoAno";
import CurvaABC from "@/models/enum/produto/curvaABC";
import SituacoesVenda from "@/models/enum/situacoesVenda";
import StatusEnvioNF from "@/models/enum/statusEnvioNF";
import SubGrupoProduto from "@/models/enum/subGrupoProduto";
import TipoDado from "@/models/enum/tipoDado";
import TipoNotaFiscal from "@/models/enum/tipoNotaFiscal";
import TiposFranquia from "@/models/enum/tiposFranquia";
import TiposMovimentacaoEstoque from "@/models/enum/tiposMovimentacaoEstoque";
import Ufs from "@/models/enum/ufs";
import FranquiaModel from "@/models/franquiaModel";
import RacaAnimalModel from "@/models/paciente/racaAnimalModel";
import PaginationModel from "@/models/paginationModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import RelatorioBaseModel from "@/models/relatorios/base/relatorioBaseModel";
import FiltersRelatorioModel from "@/models/relatorios/filtersRelatorioModel";
import RelatorioModel from "@/models/relatorios/relatorioModel";
import TemplateRelatorioModel from "@/models/templateRelatorioModel";
import UsuarioModel from "@/models/usuarioModel";
import BeneficioService from "@/services/beneficioService";
import campanhaService from "@/services/campanhaService";
import CategoriaControleReclamacaoService from "@/services/categoriaControleReclamacaoService";
import ClienteService from "@/services/clienteService";
import ColaboradorService from "@/services/colaboradorService";
import ConvenioService from "@/services/convenioService";
import CupomService from "@/services/CupomService";
import EspecialidadeService from "@/services/especialidadeService";
import estoqueByFranquiaService from "@/services/estoqueByFranquiaService";
import estoqueService from "@/services/estoqueService";
import EtapaPCPService from "@/services/etapaPCPService";
import CidadeService from "@/services/external/cidadeService";
import ContaCorrenteService from "@/services/financeiro/contaCorrenteService";
import ContaGerencialService from "@/services/financeiro/contaGerencialService";
import FormaPagamentoService from "@/services/financeiro/formaPagamentoService";
import FormaRecebimentoService from "@/services/financeiro/formaRecebimentoService";
import OperadoraCartoesService from "@/services/financeiro/operadoraCartoesService";
import formaFarmaceuticaService from "@/services/formaFarmaceuticaService";
import FornecedorService from "@/services/fornecedorService";
import franquiaService from "@/services/franquiaService";
import JustificativaControleReclamacaoService from "@/services/justificativaControleReclamacaoService";
import MotivoMovimentacaoEstoqueService from "@/services/motivoMovimentacaoEstoque";
import MotivoRejeicaoService from "@/services/motivoRejeicaoService";
import naturezaOperacaoService from "@/services/naturezaOperacaoService";
import EspecieAnimalService from "@/services/paciente/especieAnimalService";
import PacienteService from "@/services/paciente/pacienteService";
import RacaAnimalService from "@/services/paciente/racaAnimalService";
import RelatorioPdfService from "@/services/pdf/relatorioPdfService";
import PrescritorService from "@/services/prescritorService";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import produtoService from "@/services/produto/produtoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import RelatorioService from "@/services/relatorioService";
import setorService from "@/services/setorService";
import SNGPCProdutoSobraService from "@/services/sngpc/sNGPCProdutoSobraService";
import templateRelatorioService from "@/services/templateRelatorioService";
import tipoVendaService from "@/services/tipoVendaService";
import localEntregaService from "@/services/transporte/localEntregaService";
import TransportadoraService from "@/services/transporte/transportadoraService";
import vendedorService from "@/services/vendedorService";
import VisitadorService from "@/services/visitadorService";
import { AppState, Getters } from "@/store/store";
import arithmeticHelper from "@/utils/common/arithmeticHelper";
import { changePosition } from "@/utils/common/array";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";
import { applyTimeZoneDifference } from "@/utils/common/date";
import FileHelper from "@/utils/common/fileHelper";
import { formatMoney } from "@/utils/common/number";
import _ from "lodash";
import moment from "moment";
import { includes, isNotEmpty } from "ramda";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import "../crud/crud.scss";

type CampoType = {
    descricao: string;
};

const templateProdutoDefaultOptions = [
    {
        text: "[PADRÃO] Dados Gerais",
        value: 0,
    },
    {
        text: "[PADRÃO] Dados Manipulação",
        value: 1,
    },
    {
        text: "[PADRÃO] Dados Financeiros",
        value: 2,
    },
    {
        text: "[PADRÃO] Dados Fiscais",
        value: 3,
    },
];

const templateClienteDefaultOptions = [
    {
        text: "[PADRÃO] Dados Gerais",
        value: 0,
    },
];

const camposDefaultProduto = [
    {
        value: 0,
        campos: [
            { descricao: "Descricao" },
            { descricao: "Ativo" },
            { descricao: "GrupoProduto" },
            { descricao: "SubGrupo" },
            { descricao: "UnidadeMedidaEstoque" },
            { descricao: "CurvaABC" },
        ],
    },
    {
        value: 1,
        campos: [
            { descricao: "Descricao" },
            { descricao: "UnidadeMedidaManipulacao" },
            { descricao: "TipoCalculo" },
            { descricao: "ListaControlado" },
            { descricao: "FatorCorrecao" },
            { descricao: "Densidade" },
            { descricao: "CurvaABC" },
        ],
    },
    {
        value: 2,
        campos: [
            { descricao: "Descricao" },
            { descricao: "ValorCusto" },
            { descricao: "CustoReferencia" },
            { descricao: "ValorVenda" },
            { descricao: "Markup" },
            { descricao: "CurvaABC" },
        ],
    },
    {
        value: 3,
        campos: [
            { descricao: "Descricao" },
            { descricao: "OrigemMercadoria" },
            { descricao: "CstICMS" },
            { descricao: "CstIPIEntrada" },
            { descricao: "CstIPISaida" },
            { descricao: "CstPISEntrada" },
            { descricao: "CstPISSaida" },
            { descricao: "CstCOFINSEntrada" },
            { descricao: "CstCOFINSSaida" },
        ],
    },
];

const camposDefaultCliente = [
    {
        value: 0,
        campos: [
            { descricao: "Nome" },
            { descricao: "Cpf" },
            { descricao: "Cnpj" },
            { descricao: "Endereco" },
            { descricao: "Bairro" },
            { descricao: "Estado" },
            { descricao: "Cidade" },
            { descricao: "Cep" },
        ],
    },
];

const serviceMap = new Map<string, any>([
    ["BeneficioService", BeneficioService],
    ["CategoriaControleReclamacaoService", CategoriaControleReclamacaoService],
    ["ClienteService", ClienteService],
    ["ContaCorrenteService", ContaCorrenteService],
    ["ContaGerencialService", ContaGerencialService],
    ["ConvenioService", ConvenioService],
    ["CupomService", CupomService],
    ["EspecialidadeService", EspecialidadeService],
    ["EtapaPCPService", EtapaPCPService],
    ["FormaPagamentoService", FormaPagamentoService],
    ["FormaRecebimentoService", FormaRecebimentoService],
    ["FornecedorService", FornecedorService],
    ["JustificativaControleReclamacaoService", JustificativaControleReclamacaoService],
    ["MotivoMovimentacaoEstoqueService", MotivoMovimentacaoEstoqueService],
    ["MotivoRejeicaoService", MotivoRejeicaoService],
    ["OperadoraCartoesService", OperadoraCartoesService],
    ["PacienteService", PacienteService],
    ["PrescritorService", PrescritorService],
    ["TransportadoraService", TransportadoraService],
    ["VisitadorService", VisitadorService],
    ["SNGPCProdutoSobraService", SNGPCProdutoSobraService],
]);

const cachedServiceMap = new Map<string, any>([
    ["CampanhaService", campanhaService],
    ["ColaboradorService", ColaboradorService],
    ["EspecieAnimalService", EspecieAnimalService],
    ["EstoqueService", estoqueService],
    ["EstoqueByFranquiaService", estoqueByFranquiaService],
    ["FranquiaService", franquiaService],
    ["FranquiaMatrizService", franquiaService],
    ["FormaFarmaceuticaService", formaFarmaceuticaService],
    ["GrupoProdutoService", grupoProdutoService],
    ["LocalEntregaService", localEntregaService],
    ["NaturezaOperacaoService", naturezaOperacaoService],
    ["ProdutoDrogavetService", produtoService],
    ["ProdutoService", produtoService],
    ["ProdutoControladoService", produtoService],
    ["SetorService", setorService],
    ["TipoVendaService", tipoVendaService],
    ["UsuarioService", vendedorService],
]);

const enumsMap = new Map<string, EnumExtensions>([
    ["StatusEnvioNF", StatusEnvioNF],
    ["TiposMovimentacaoEstoque", TiposMovimentacaoEstoque],
    ["MesesDoAno", MesesDoAno],
    ["Ufs", Ufs],
    ["SituacoesVenda", SituacoesVenda],
    ["CurvaABC", CurvaABC],
    ["ControleReclamacaoStatus", ControleReclamacaoStatus],
    ["SubGrupoProduto", SubGrupoProduto],
    ["TipoNotaFiscal", TipoNotaFiscal],
    ["GatewayPagamentoProvider", GatewayPagamentoProvider],
]);

function toSnakeCase(text: string) {
    return text.charAt(0).toLowerCase() + text.slice(1);
}

const relatorioVendaPorProdutoId = 52;
const relatorioCoberturaEstoqueId = 2;
const camposDependentesFranquiaVendaPorProduto = [
    "grupoProduto",
    "subGrupo",
    "produto",
    "paciente",
    "tipoVenda",
    "formaFarmaceutica",
];
const camposDependentesFranquiaCoberturaEstoque = ["grupo", "estoque"];

@Component({
    components: {
        checkboxComponent,
        dataTooltipComponent,
        comboComponent,
        gridComponent,
        dateTimePickerComponent,
        actionBarComponent,
        multiselectComponent,
        searchComboComponent,
        configuracoesImpresaoXLSComponent,
        configuracoesImpresaoPDFComponent,
        criteriosComponent,
        searchComboMultiSelectComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS", "GET_FRANQUIA_ATUAL"] as Getters),
    },
})
export default class RelatorioViewComponent extends Vue {
    // State computed props
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;
    GET_FRANQUIA_ATUAL: () => Promise<FranquiaModel>;
    usuarioLogado: UsuarioModel;

    private gridcomponent: Grid = null;
    private service = new RelatorioService();
    private relatorioPdfService = new RelatorioPdfService("RelatorioPDF");
    private cidadeService = new CidadeService();
    private produtoLoteService = new ProdutoLoteService();
    private cupomService = new CupomService();
    private clienteService = new ClienteService();
    private racaAnimalService = new RacaAnimalService();
    private lista: Array<Object> = [];
    model = new RelatorioBaseModel();
    modelId = 0;
    comboOptions: Array<Object> = [];
    uf: number = null;
    produtoId: number = null;
    franquiaId: number | null = null;
    private franquiaCoberturaEstoqueId: number | null = null;
    especieId: number = null;
    showExpand = false;

    private configuracoesImpresaoPDFComponent: ConfiguracoesImpresaoPDFComponent = null;
    private configuracoesImpresaoXLSComponent: ConfiguracoesImpresaoXLSComponent = null;
    private criteriosComponent: CriteriosComponent = null;

    gridFilterKey = "";
    gridSortKey = "";
    gridSortOrder = "";
    gridData: Array<Object> = [];
    gridColumns: Array<GridColumn> = [new GridColumn("", "", GridColumnType.String)];
    gridColumnsVinculos: Array<GridColumn> = [new GridColumn("", "", GridColumnType.String)];

    totais = [];

    pageIndex = 1;
    pageSize = 30;
    total = 0;

    pags = true;
    tipoDocGerar: number = null;
    footer: Object = null;
    isFracionamento = false;
    isEstereis = false;
    hasSubItens = false;

    private isCustomFields = false;
    private isTemplateDefault = true;
    private campoId = null;
    private templateId = null;
    private camposOptions = [];
    private templateOptions = [];
    private templates = [];

    private camposSelecionados: CampoType[] = [];
    private camposGridColumns = [new GridColumn("descricao", "Descrição", GridColumnType.String)];

    private extraActions: Array<object> = [];
    private gridExtraActionsUp: Array<GridAction> = [];
    private gridExtraActionsDown: Array<GridAction> = [];

    constructor() {
        super();
    }

    public temModelo() {
        return this.model.nomeRelatorio != null;
    }

    private async load() {
        try {
            const data = await this.service.get(this.modelId).withLoading().resolveWithJSON<RelatorioBaseModel>();
            this.model.updateFrom(data);
        } catch {}

        if (this.modelId == 19 || this.modelId == 70) {
            await this.loadTemplate();
        }

        if (!this.temModelo()) {
            return;
        }
        if (this.model.filters != null && this.model.filters.length > 0) {
            for (let filter of this.model.filters) {
                if (filter.valor == null) {
                    filter = this.getDefaultFieldValue(filter);
                }
                switch (filter.tipoDado) {
                    case TipoDado.MultiSelect:
                        filter = await this.getComboOptionsMultiSelect(filter);
                        break;
                    case TipoDado.SearchComboMultiSelect:
                        filter = await this.prepareSearchComboMultiSelect(filter);
                        break;
                    case TipoDado.Enum:
                        filter = this.getComboOptionsEnum(filter);
                        break;
                    case TipoDado.Combo:
                        filter = await this.getComboOptions(filter);
                        break;
                    case TipoDado.Boolean:
                        filter = this.getComboOptionsBool(filter);
                        break;
                    default:
                        break;
                }
            }
        }

        if (this.model && (this.model.filters == null || this.model.filters.length == 0)) {
            await this.search();
        }
    }

    private getDefaultFieldValue(filter: FiltersRelatorioModel) {
        switch (filter.nomeCampo) {
            case "dataInicial":
                filter.valor = moment(new Date()).subtract(1, "month").toDate();
                break;
            case "dataFinal":
                filter.valor = moment(new Date()).add(1, "month").toDate();
                break;
            default:
                break;
        }

        return filter;
    }

    private async getComboOptionsMultiSelect(filter: FiltersRelatorioModel) {
        filter.comboOptions = filter.valorMultiSelect;

        if (filter.comboLoad && filter.comboLoad.includes("SituacoesVenda")) {
            filter.comboOptions = EnumExtensions.getNamesAndValuesOrderedByNames(enumsMap.get("SituacoesVenda"));

            if (filter.comboLoad == "SituacoesVendaAprovada") {
                filter.comboOptions = filter.comboOptions.filter(
                    p => p["value"] != 0 && p["value"] != 1 && p["value"] != 5,
                );
            }

            if (filter.comboLoad == "SituacoesVendaFaturado") {
                filter.comboOptions = filter.comboOptions.filter(
                    p => p["value"] != 0 && p["value"] != 1 && p["value"] != 2 && p["value"] != 5,
                );
            }

            if (!this.isFracionamento) {
                filter.comboOptions = filter.comboOptions.filter(p => p["value"] <= 6);
            }
        } else if (filter.comboLoad && filter.comboLoad.includes("TiposMovimentacaoEstoque")) {
            filter = this.getComboOptionsEnum(filter);
        } else {
            filter = await this.getComboOptions(filter);
        }

        await this.setFranquiaAtual(filter);

        return filter;
    }

    private async setFranquiaAtual(filter: FiltersRelatorioModel) {
        const relatoriosSelecionaFranquiaAtual = [55, relatorioCoberturaEstoqueId];
        const setFranquiaAtual =
            includes(this.modelId, relatoriosSelecionaFranquiaAtual) && filter.nomeCampo == "franquias";
        if (!setFranquiaAtual) {
            return;
        }

        if (filter.valorMultiSelect && isNotEmpty(filter.valorMultiSelect)) {
            return;
        }

        const franquiaAtual: FranquiaModel = await this.GET_FRANQUIA_ATUAL();
        if (!franquiaAtual?.id) {
            return;
        }

        const opcaoFranquiaAtual = filter.comboOptions.find(p => Number(p["value"] ?? p["id"]) == franquiaAtual.id);
        if (opcaoFranquiaAtual) {
            filter.valorMultiSelect = [opcaoFranquiaAtual];
        }
    }

    private getComboOptionsEnum(filter: FiltersRelatorioModel) {
        switch (filter.comboLoad) {
            case "MesesDoAno":
                filter.comboOptions = EnumExtensions.getNamesAndValuesOrderedByValues(enumsMap.get(filter.comboLoad));
                break;
            default:
                filter.comboOptions = EnumExtensions.getNamesAndValuesOrderedByNames(enumsMap.get(filter.comboLoad));
        }

        return filter;
    }

    private getComboOptionsBool(filter: FiltersRelatorioModel) {
        if (filter.valor == "false") {
            filter.valor = false;
        } else {
            filter.valor = true;
        }

        return filter;
    }

    private async getComboOptions(filter: FiltersRelatorioModel) {
        let dataCombo = null;
        const isCachedService = cachedServiceMap.has(filter.comboLoad);
        const franquiaIdCombo = this.getFranquiaIdCombo(filter);

        if (this.isFiltroDependenteFranquiaVendaPorProduto(filter)) {
            if (!franquiaIdCombo || this.isFormaFarmaceuticaVendaPorProdutoFracionadora(filter)) {
                filter.comboOptions = [];
                return filter;
            }
        }

        if (this.isFiltroDependenteFranquiaCoberturaEstoque(filter) && !franquiaIdCombo) {
            filter.comboOptions = [];
            return filter;
        }

        if (isCachedService) {
            if (filter.comboLoad === "ProdutoControladoService") {
                const responseCombo = await produtoService.comboCached(
                    franquiaIdCombo || this.usuarioLogado.franquiaId,
                );
                dataCombo = responseCombo.filter(p => p.listaControladoId) || [];
            } else if (
                this.isFiltroDependenteFranquiaCoberturaEstoque(filter) &&
                this.isFranquiaDiferenteDaCorrente(franquiaIdCombo)
            ) {
                // O combo padrão resolve a franquia pela sessão; outra franquia exige o combo por franquiaId
                dataCombo = await cachedServiceMap.get(filter.comboLoad).comboCachedByFranquiaId(franquiaIdCombo);
            } else {
                dataCombo = await cachedServiceMap.get(filter.comboLoad).comboCached(franquiaIdCombo);
            }
        } else {
            switch (filter.comboLoad) {
                case "RacaAnimalService":
                    dataCombo = [];
                    break;
                case "PacienteService":
                    try {
                        const pacienteService = new PacienteService();
                        const responseCombo = await pacienteService.list("", "nome", "asc", 1, 999999, {
                            franquiaId: franquiaIdCombo,
                        });
                        const jsonData = await responseCombo.json();
                        dataCombo = jsonData.list || [];
                    } catch {
                        dataCombo = [];
                    }
                    break;
                case "PrescritorService":
                case "CidadeService":
                case "ProdutoLoteService":
                case "ByFranquia":
                    break;
                case "FranquiaMatrizService":
                    const responseCombo = await franquiaService
                        .ListFranquiasMatrizFiliais()
                        .resolveWithJSON<FranquiaModel>();

                    dataCombo = responseCombo || [];
                    break;
                default:
                    try {
                        const responseCombo = await new (serviceMap.get(filter.comboLoad))()["combo"]();
                        dataCombo = (await responseCombo.json()).list;
                    } catch {
                        dataCombo = [];
                    }
                    break;
            }
        }

        if (filter.comboLoad == "FranquiaService") {
            dataCombo = (dataCombo || []).filter(p => p["redeId"] == 6);
        }

        if (isCachedService) {
            filter.comboOptions = dataCombo || [];
            if (filter.comboOptions.length > 0 && filter.comboOptions[0].hasOwnProperty("text")) {
                return filter;
            }

            filter.comboOptions = (dataCombo as any[]).map(p => ({
                ...p,
                value: p.value || p.id,
                text: p.text || p.descricao || p.razaoSocial || p.nome || p.nomeFantasia,
            }));
        } else {
            switch (filter.comboLoad) {
                case "ProdutoDrogavetService":
                    filter.comboOptions = dataCombo
                        .filter(p => p.produtoPaiId)
                        .map(p => ({
                            value: p.produtoPaiId,
                            text: p.descricao,
                        }));
                    break;
                case "PacienteService":
                    filter.comboOptions = dataCombo.map(p => ({
                        value: p.id,
                        text: `${p.nome} - (${p.clienteDescricao || ""})`,
                    }));
                    break;
                case "PrescritorService":
                case "ProdutoLoteService":
                case "CidadeService":
                    break;
                case "ByFranquia":
                case "RacaAnimalService":
                    filter.comboOptions = [];
                    break;
                default:
                    filter.comboOptions = dataCombo.map(p => ({
                        value: p.id,
                        text: p.descricao || p.razaoSocial || p.nome || p.nomeFantasia,
                    }));
                    break;
            }
        }

        return filter;
    }

    private async prepareSearchComboMultiSelect(filter: FiltersRelatorioModel) {
        const serviceName = filter.comboLoad;

        if (serviceName === "ClienteService") {
            filter.serviceInstance = new ClienteService();
        } else if (serviceMap.has(serviceName)) {
            const ServiceClass = serviceMap.get(serviceName);
            filter.serviceInstance = new ServiceClass();
        } else {
            filter.serviceInstance = null;
        }

        filter.comboOptions = [];
        filter.selectedItems = [];

        return filter;
    }

    private onSearchComboMultiSelectChange(filter: FiltersRelatorioModel, selectedItems: any[]) {
        filter.selectedItems = selectedItems;
        filter.valorMultiSelect = selectedItems.map(p => ({
            Text: p.text ?? p.Text ?? p.nome ?? p.Nome,
            Value: String(p.id ?? p.Id),
        }));
    }

    public async downloadXLS() {
        this.configuracoesImpresaoXLSComponent = this.$refs
            .configuracoesImpresaoXLSComponent as ConfiguracoesImpresaoXLSComponent;
        this.configuracoesImpresaoXLSComponent.open();
    }

    public async downloadPDF() {
        this.configuracoesImpresaoPDFComponent = this.$refs
            .configuracoesImpresaoPDFComponent as ConfiguracoesImpresaoPDFComponent;
        this.configuracoesImpresaoPDFComponent.open();
    }

    private exibirCriterios() {
        this.criteriosComponent = this.$refs.criteriosComponent as CriteriosComponent;
        this.criteriosComponent.open();
    }

    private async onConfirmXLS(data: ConfiguracaoImpressaoModel) {
        this.model.exportacao = data;

        try {
            const dataModel = this.formatDadosRelatorio();
            const response = await this.service.getRelatorioXLS(dataModel).withLoading().resolveWithResponse();
            const data = await response.blob();

            const blob = new Blob([data], { type: response.headers.get("Content-Type") });
            const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];
            FileHelper.download(blob, fileName);
        } catch {}
    }

    public async onConfirmPDF(data: ConfiguracaoImpressaoModel) {
        this.model.exportacao = data;

        const dataModel = this.formatDadosRelatorio();
        await this.relatorioPdfService.getRelatorioPdf(dataModel, this.gridSortKey, this.gridSortOrder);
    }

    private async search(edit = false) {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                this.gridData = [];

                if (!edit) {
                    if (this.isCustomFields && this.camposSelecionados.length == 0) {
                        return this.$showError("Erro", "Selecione ao menos um campo!");
                    }

                    this.model.campos = this.camposSelecionados.reduce(
                        (acc, p) => (acc ? acc + `,${p.descricao}` : acc + p.descricao),
                        "",
                    );

                    const dataModel = this.formatDadosRelatorio();

                    const data = await this.service
                        .getRelatorio(dataModel)
                        .withLoading()
                        .resolveWithJSON<RelatorioModel>();

                    this.lista = [];
                    for (let i = 0; i < data.dados.length; i++) {
                        this.lista.push(
                            Object.keys(data.dados[i]).reduce(
                                (acc, p) => (acc = { ...acc, [toSnakeCase(p)]: data.dados[i][p] }),
                                {},
                            ),
                        );
                    }
                    this.total = data.dados.length;
                    for (let i = 0; i < this.pageSize && i < this.total; i++) {
                        this.gridData.push(this.lista[i]);
                    }

                    this.gridColumns = [
                        ...data.cabecalho.map(cab => {
                            const column = new GridColumn(toSnakeCase(cab.valor), cab.descricao, cab.tipoDado);
                            column.minimumFractionDigits = cab.casasDecimais;
                            return column;
                        }),
                    ];

                    this.hasSubItens = data.cabecalhoSubItens.length > 0;

                    if (this.hasSubItens) {
                        this.showExpand = true;

                        this.gridColumnsVinculos = [
                            ...data.cabecalhoSubItens.map(cab => {
                                const column = new GridColumn(toSnakeCase(cab.valor), cab.descricao, cab.tipoDado);
                                column.minimumFractionDigits = cab.casasDecimais;
                                return column;
                            }),
                        ];
                    } else {
                        this.showExpand = false;
                    }

                    this.totais = data.totais.map(total => ({
                        ...total,
                        valor: this.editTotalValue(total.tipoDado, total.valor, total.casasDecimais),
                    }));
                } else {
                    let i = this.pageSize * this.pageIndex - this.pageSize;
                    if (i <= 0) {
                        i = 0;
                    }
                    let j = i > 0 ? 0 : i;
                    for (i; j < this.pageSize && i < this.total; i++) {
                        this.gridData.push(this.lista[i]);
                        j++;
                    }
                    if (this.pags) {
                        this.gridData = [];
                        for (i = 0; i < this.total; i++) {
                            this.gridData.push(this.lista[i]);
                        }

                        if (this.tipoDocGerar == 2) {
                            setTimeout(() => {
                                this.gridcomponent.gerarImpressao();
                            }, 2000);
                        }

                        setTimeout(() => {
                            this.pags = false;
                        }, 2000);
                    }
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private clear() {
        this.model = new RelatorioBaseModel();
        this.modelId = 0;
        this.total = 0;
        this.gridData = [];
        this.gridColumns = [];
        this.gridColumnsVinculos = [];
        this.showExpand = false;
        this.pageIndex = 1;
        this.pageSize = 30;
        this.total = 0;
        this.pags = false;
    }

    private reset() {
        this.total = 0;
        this.gridData = [];
        this.gridColumns = [];
        this.gridColumnsVinculos = [];
        this.showExpand = false;
        this.pageIndex = 1;
        this.pageSize = 30;
        this.total = 0;
        this.pags = false;
        this.load();
    }

    private onChangeFilterKey(filterKey: string) {
        this.gridFilterKey = filterKey;
        this.search(true);
    }

    @Watch("pags")
    private onPags() {
        this.search(true);
    }

    private onChangeSort(sortKey: string, sortOrder: string) {
        this.gridSortKey = sortKey;
        this.gridSortOrder = sortOrder;
        this.lista.sort((atual, proximo) => {
            const x = atual[this.gridSortKey];
            const y = proximo[this.gridSortKey];
            if (this.gridSortOrder == "asc") {
                if (x < y) return -1;
                if (x > y) return 1;
                return 0;
            } else {
                if (x > y) return -1;
                if (x < y) return 1;
                return 0;
            }
        });
        this.search(true);
    }

    private onChangePage(pageIndex: number) {
        this.pageIndex = pageIndex;
        this.search(true);
    }

    private editTotalValue(tipoDado: TipoDado, value: string, casasDecimais: number) {
        switch (tipoDado) {
            case TipoDado.Money:
                return formatMoney(Number(value.replace(",", ".")), casasDecimais);
            case TipoDado.Decimal:
                if (isNaN(Number(value))) {
                    return value;
                }
                return arithmeticHelper.round(Number(value), casasDecimais);
            case TipoDado.Integer:
                return Number(value);
            case TipoDado.Percent:
                return value.replace(".", ",") + " %";
            default:
                return value;
        }
    }

    private formatDadosRelatorio() {
        const dataModel = _.cloneDeep(this.model) as RelatorioBaseModel;

        for (const item of dataModel.filters.filter(
            p => p.tipoDado == TipoDado.DateTime || p.tipoDado == TipoDado.Date,
        )) {
            if (item && item.valor) {
                item.valor = applyTimeZoneDifference(item.valor, true);
            }
        }

        for (const filter of dataModel.filters) {
            if (
                filter.tipoDado === TipoDado.SearchComboMultiSelect &&
                filter.selectedItems &&
                filter.selectedItems.length > 0
            ) {
                filter.valorMultiSelect = filter.selectedItems.map((item: any) => ({
                    Value: String(item.value),
                    Text: item.text,
                }));
            }
        }

        return dataModel;
    }

    //@ts-ignore
    @Watch("isCustomFields")
    private async onChangeIsCustomFields() {
        if (this.isCustomFields) {
            let data = null;
            switch (this.modelId) {
                default:
                case 19:
                    data = await produtoService.getCamposDescricao().resolveWithJSON<string[]>();
                    break;
                case 70:
                    data = await new ClienteService().getCamposDescricao().resolveWithJSON<string[]>();
            }

            this.camposOptions = data.map((p, index) => ({ value: index, text: p }));
        }
    }

    //@ts-ignore
    @Watch("templateId")
    private async onChangeTemplateId() {
        if (this.templateId != null && this.templateId >= 0) {
            this.isTemplateDefault = !this.templateOptions.find(p => p.value == this.templateId).id;

            switch (this.modelId) {
                default:
                case 19:
                    this.camposSelecionados = this.templates.find(p => p.value == this.templateId).campos;
                    break;
                case 70:
                    this.camposSelecionados = this.templates.find(p => p.value == this.templateId).campos;
                    break;
            }
            this.addAcoesGrid();
        } else {
            this.camposSelecionados = [];
            this.isTemplateDefault = true;
        }
    }

    private async onDeleteTemplate() {
        const response = await this.$showQuestion("Tem certeza?", "Deseja realmente apagar o template?");

        if (response) {
            const indexTemplate = this.templateOptions.findIndex(p => p.value == this.templateId);
            if (this.templateOptions[indexTemplate].id) {
                await templateRelatorioService.delete(this.templateOptions[indexTemplate].id);

                this.templateId = null;
                this.templates.splice(indexTemplate, 1);

                this.loadTemplate();
            }
        }
    }

    private async onSaveTamplate() {
        const response = await this.$showAlert({
            title: "Insira um nome para o template",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Salvar",
            cancelButtonText: "Fechar",
            input: "textarea",
            inputValidator: result => {
                if (!result) {
                    return "Necessário informar uma descrição para o template.";
                }
                return "";
            },
        });

        if (response.isConfirmed) {
            const template = new TemplateRelatorioModel();
            template.usuarioId = this.usuarioLogado.id;
            template.campos = JSON.stringify(this.camposSelecionados.map(p => p.descricao));
            template.relatorio = this.modelId;
            template.descricao = response.value;

            await templateRelatorioService.insert(template);

            await this.loadTemplate();
            this.templateId = this.templateOptions[this.templateOptions.length - 1].value;
        }
    }

    public async loadTemplate() {
        this.templateOptions =
            this.modelId == 19 ? [...templateProdutoDefaultOptions] : [...templateClienteDefaultOptions];
        this.templates = this.modelId == 19 ? [...camposDefaultProduto] : [...camposDefaultCliente];

        const response = await templateRelatorioService.getTemplates(this.modelId);

        if (response.length > 0) {
            response.forEach(p => {
                this.templateOptions.push({ text: p.descricao, value: this.templates.length, id: p.id });
                this.templates.push({
                    value: this.templates[this.templates.length - 1].value + 1,
                    campos: JSON.parse(p.campos).map(x => ({ descricao: x })),
                });
            });
        }
    }

    @Watch("produtoId")
    private async onChangeProdutoId() {
        const index = this.model.filters.findIndex(p => p.nomeCampo == "produtoWithLote");

        if (index > -1) {
            this.model.filters[index].valor = this.produtoId;
            const indexLote = this.model.filters.findIndex(p => p.nomeCampo == "lote");
            if (this.produtoId) {
                const data = await this.produtoLoteService
                    .getByProdutoId(this.produtoId, 0)
                    .withLoading()
                    .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();

                const exibeCodigo = this.isFracionamento || this.isEstereis;
                this.model.filters[indexLote].comboOptions = data.list.map(item =>
                    getProdutoLoteCombo(item, exibeCodigo),
                );
            } else {
                this.model.filters[indexLote].comboOptions = [];
            }
        }
    }

    @Watch("franquiaId")
    private async onChangeFranquiaId() {
        if (!this.franquiaId) {
            return;
        }

        const campoFranquia = this.model.filters.find(p => p.nomeCampo == "franquia");

        if (!campoFranquia) {
            return;
        }

        campoFranquia.valor = this.franquiaId;
        campoFranquia.valor = this.franquiaId;

        await this.reloadCombosByFranquia();
        await this.reloadFiltrosDependentesFranquia();
    }

    private async reloadCombosByFranquia() {
        const campoFiltrar = this.model.filters.find(p => p.comboLoad == "ByFranquia");

        if (!campoFiltrar) {
            return;
        }

        const campoFiltrarTipo = campoFiltrar.nomeCampo?.toLowerCase();

        if (!campoFiltrarTipo) {
            campoFiltrar.comboOptions = [];
            return;
        }

        const services: Record<string, any> = {
            cupom: this.cupomService,
            cliente: this.clienteService,
        };

        const service = services[campoFiltrarTipo];

        if (!service || !this.franquiaId) {
            campoFiltrar.comboOptions = [];
            return;
        }

        const data = await service.listByFranquiaId(this.franquiaId).withLoading().resolveWithJSON();

        const lista = Array.isArray(data) ? data : data?.list ?? [];

        campoFiltrar.comboOptions = lista.map(p => ({
            value: p.id,
            text: (p[campoFiltrarTipo] || p.nome) + (p.descricao ? ` - ${p.descricao}` : ""),
        }));
    }

    private async reloadFiltrosDependentesFranquia() {
        const dependentes = this.model.filters.filter(p => this.isFiltroDependenteFranquiaVendaPorProduto(p));

        await this.reloadCombosFiltrosDependentes(dependentes);
    }

    private syncFranquiaCoberturaEstoque() {
        if (this.modelId != relatorioCoberturaEstoqueId) {
            return;
        }

        this.franquiaCoberturaEstoqueId = this.getFranquiaIdCoberturaEstoque();
    }

    @Watch("franquiaCoberturaEstoqueId")
    private async onChangeFranquiaCoberturaEstoqueId() {
        const dependentes = this.model.filters?.filter(p => this.isFiltroDependenteFranquiaCoberturaEstoque(p));

        await this.reloadCombosFiltrosDependentes(dependentes);
    }

    private async reloadCombosFiltrosDependentes(dependentes: FiltersRelatorioModel[]) {
        if (!dependentes || dependentes.length == 0) {
            return;
        }

        for (const filter of dependentes) {
            filter.valor = null;
            filter.valorMultiSelect = [];
            filter.selectedItems = [];
            filter.comboOptions = [];
        }

        for (const filter of dependentes) {
            switch (filter.tipoDado) {
                case TipoDado.MultiSelect:
                    await this.getComboOptionsMultiSelect(filter);
                    break;
                case TipoDado.Enum:
                    this.getComboOptionsEnum(filter);
                    break;
                case TipoDado.Combo:
                    await this.getComboOptions(filter);
                    break;
                default:
                    break;
            }
        }
    }

    @Watch("model.filters", { deep: true })
    private async onChangeFilters() {
        this.syncFranquiaCoberturaEstoque();
        await this.loadFranchise();
    }

    private async loadFranchise() {
        const campofranquia = this.model.filters.find(p => p.nomeCampo == "franquia");
        if (campofranquia?.comboOptions != null && campofranquia?.comboOptions.length && !this.franquiaId) {
            const franquiaAtual: FranquiaModel = await this.GET_FRANQUIA_ATUAL();
            this.franquiaId = franquiaAtual.id || null;
        }
    }

    //@ts-ignore
    @Watch("uf")
    private async onChangeUf() {
        const index = this.model.filters.findIndex(p => p.nomeCampo == "uf");
        if (index > -1) {
            this.model.filters[index].valor = this.uf;
            const indexCidade = this.model.filters.findIndex(p => p.nomeCampo == "cidade");
            const cidadesOptions = await this.cidadeService.get(this.uf).withLoading();
            this.model.filters[indexCidade].comboOptions = cidadesOptions
                .sort((a, b) => (a.text > b.text ? 1 : -1))
                .map(x => ({
                    text: x.text,
                    value: x.value,
                }));
        }
    }

    @Watch("especieId")
    private async onChangeEspecieId() {
        const indexEspecie = this.model.filters.findIndex(p => p.nomeCampo == "especie");

        if (indexEspecie > -1) {
            this.model.filters[indexEspecie].valor = this.especieId;
            const indexRaca = this.model.filters.findIndex(p => p.nomeCampo == "raca");

            if (indexRaca > -1) {
                this.model.filters[indexRaca].comboOptions = [];

                if (this.especieId) {
                    try {
                        const data = await this.racaAnimalService
                            .listByEspecie(this.especieId)
                            .withLoading()
                            .resolveWithJSON<RacaAnimalModel[]>();

                        this.model.filters[indexRaca].comboOptions = data.map(r => ({
                            value: r.id,
                            text: r.descricao,
                        }));

                        this.model.filters[indexRaca].valor = null;
                    } catch {
                        this.model.filters[indexRaca].comboOptions = [];
                    }
                } else {
                    this.model.filters[indexRaca].comboOptions = [];
                    this.model.filters[indexRaca].valor = null;
                }
            }
        }
    }

    private getFranquiaIdCombo(filter: FiltersRelatorioModel) {
        if (this.isFiltroDependenteFranquiaVendaPorProduto(filter)) {
            return this.franquiaId;
        }

        if (this.isFiltroDependenteFranquiaCoberturaEstoque(filter)) {
            return this.getFranquiaIdCoberturaEstoque();
        }

        return this.usuarioLogado.franquiaId;
    }

    private isFranquiaDiferenteDaCorrente(franquiaIdCombo: number | null) {
        return !!franquiaIdCombo && franquiaIdCombo != this.usuarioLogado.franquiaId;
    }

    private getFranquiaIdCoberturaEstoque() {
        const campoFranquias = this.model.filters?.find(p => p.nomeCampo == "franquias");
        const franquiasSelecionadas = campoFranquias?.valorMultiSelect ?? [];

        if (franquiasSelecionadas.length > 1) {
            return null;
        }

        if (franquiasSelecionadas.length == 0) {
            return this.usuarioLogado?.franquiaId ?? null;
        }

        const franquiaSelecionada = franquiasSelecionadas[0];

        return Number(franquiaSelecionada["value"] ?? franquiaSelecionada["Value"]) || null;
    }

    private getFranquiaSelecionada() {
        const filter = this.model.filters.find(p => p.nomeCampo == "franquia");

        if (!this.franquiaId || !filter || !filter.comboOptions) {
            return null;
        }

        return filter.comboOptions.find(p => Number(p["value"]) == this.franquiaId) as FranquiaModel;
    }

    private isFranquiaSelecionadaFracionadora() {
        const franquia = this.getFranquiaSelecionada();
        return franquia && Number(franquia.tipoFranquia) == TiposFranquia.Fracionadora;
    }

    private isFormaFarmaceuticaVendaPorProdutoFracionadora(filter: FiltersRelatorioModel) {
        return (
            this.modelId == relatorioVendaPorProdutoId &&
            filter.nomeCampo == "formaFarmaceutica" &&
            this.isFranquiaSelecionadaFracionadora()
        );
    }

    private isFiltroDependenteFranquiaVendaPorProduto(filter: FiltersRelatorioModel) {
        return (
            this.modelId == relatorioVendaPorProdutoId &&
            camposDependentesFranquiaVendaPorProduto.includes(filter.nomeCampo)
        );
    }

    private isFiltroDependenteFranquiaCoberturaEstoque(filter: FiltersRelatorioModel) {
        return (
            this.modelId == relatorioCoberturaEstoqueId &&
            camposDependentesFranquiaCoberturaEstoque.includes(filter.nomeCampo)
        );
    }

    private onInclusaoCampo() {
        const campoComponent = this.$el.querySelector("#campoId") as HTMLSelectElement;

        if (
            campoComponent.innerText &&
            this.camposSelecionados.filter(p => p.descricao == campoComponent.innerText).length == 0
        ) {
            this.campoId = null;
            this.camposSelecionados.push({ descricao: campoComponent.innerText });

            this.addAcoesGrid();
        }
    }

    private onRemoveCampo(campo: CampoType) {
        this.camposSelecionados = this.camposSelecionados.filter(p => p.descricao != campo.descricao);
        this.addAcoesGrid();
    }

    private addAcoesGrid() {
        this.gridExtraActionsUp.splice(0);
        this.gridExtraActionsDown.splice(0);
        this.extraActions.splice(0);

        for (let i = 0; i < this.camposSelecionados.length; i++) {
            this.gridExtraActionsUp.push(
                new GridAction("up", "Colocar para cima", "fa fa-arrow-up", GridColors.DARKGRAY, true),
            );
            this.gridExtraActionsDown.push(
                new GridAction("down", "Colocar para baixo", "fa fa-arrow-down", GridColors.DARKGRAY, true),
            );
        }

        this.extraActions.push(this.gridExtraActionsUp);
        this.extraActions.push(this.gridExtraActionsDown);
    }

    private onExtraAction(name: string, campo: CampoType) {
        if (name.trim() == "up") {
            this.camposSelecionados = changePosition(this.camposSelecionados, campo, "UP");
        }

        if (name.trim() == "down") {
            this.camposSelecionados = changePosition(this.camposSelecionados, campo, "DOWN");
        }
    }

    private getColumnClass(filter: FiltersRelatorioModel) {
        if (filter.colunas > 0) {
            return `col-sm-${filter.colunas}`;
        }

        if (
            filter.tipoDado == TipoDado.Combo ||
            filter.tipoDado == TipoDado.String ||
            filter.tipoDado == TipoDado.Enum
        ) {
            if (this.model.filters.length > 2 && this.model.filters.length <= 4) {
                return "col-sm-4";
            }
            return "col-sm-3";
        } else {
            if (filter.tipoDado == TipoDado.MultiSelect) {
                return "col-sm-3";
            }
            if (filter.tipoDado == TipoDado.Boolean) {
                return "col-sm-1";
            }
            if (filter.tipoDado == TipoDado.Custom) {
                return "col-sm-3";
            }
            return "col-sm-2";
        }
    }

    private checkShowFilter(filter: FiltersRelatorioModel, filters: FiltersRelatorioModel[]) {
        if (this.isFiltroDependenteFranquiaVendaPorProduto(filter)) {
            return !!this.franquiaId && !this.isFormaFarmaceuticaVendaPorProdutoFracionadora(filter);
        }

        if (this.isFiltroDependenteFranquiaCoberturaEstoque(filter)) {
            return !!this.getFranquiaIdCoberturaEstoque();
        }

        if (filter.showOn) {
            return filters.some(eval(filter.showOn));
        }
        return true;
    }

    private checkIsCombo(filter: FiltersRelatorioModel) {
        return (
            filter.nomeCampo != "uf" &&
            filter.nomeCampo != "produtoWithLote" &&
            filter.nomeCampo != "especie" &&
            (filter.tipoDado == 10 || filter.tipoDado == 12 || filter.tipoDado == 14) &&
            filter.comboOptions != null
        );
    }

    private async mounted() {
        this.gridcomponent = this.$refs.gridcomponent as Grid;
        this.clear();

        this.modelId = +this.$route.params.id;

        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();

        if (this.modelId) {
            this.isCustomFields =
                // Relatório de dados gerais do produto
                this.modelId == 19 ||
                // Relatório de dados gerais do cliente
                this.modelId == 70;

            await this.load();

            this.loadFranchise();
        }
    }
}

